export function ConfigurationWebhook(): string {
	return `/v1/external/adyen/webhooks/configuration`;
}

export function GetOnboardingLink(organizationID: number, groupPaymentConfigID: number): string {
	return `/v1/organizations/${organizationID}/group-payment-config/${groupPaymentConfigID}/adyen-onboarding-link`;
}

export function InitiateManageDisputes(organizationID: number, groupPaymentConfigID: number): string {
	return `/v1/organizations/${organizationID}/group-payment-config/${groupPaymentConfigID}/adyen-manage-disputes`;
}

export function InitiateManageTransferInstruments(organizationID: number, groupPaymentConfigID: number): string {
	return `/v1/organizations/${organizationID}/group-payment-config/${groupPaymentConfigID}/adyen-manage-transfer-instruments`;
}

export function InitiateReporting(organizationID: number, groupPaymentConfigID: number): string {
	return `/v1/organizations/${organizationID}/group-payment-config/${groupPaymentConfigID}/adyen-reporting`;
}

export function PaymentMethodWebhook(): string {
	return `/v1/external/adyen/webhooks/payment-methods`;
}

export function PaymentWebhook(): string {
	return `/v1/external/adyen/webhooks/payments`;
}

export function ReportWebhook(): string {
	return `/v1/external/adyen/webhooks/reports`;
}

export function TransferWebhook(): string {
	return `/v1/external/adyen/webhooks/transfers`;
}

